export default __webpack_public_path__ + "img/ejgjRwVN.58845ab3.svg";